export const API_KEY = 'AIzaSyChr6ISu1u7d7BpWE-i3uJK6o9FNjg1NDU';

export const SUBLOCALITY_LEVEL_1 = 'sublocality_level_1';

export const FIRST_LEVEL = 'first_level';
export const SECOND_LEVEL = 'second_level';
